:root {
    --ux-chat-height: auto;
    max-height: 700px;
}

.ai-chat {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}

/* Style the UX Chat component */
::slotted(ux-chat) {
    height: 100%;
    min-height: 500px;
    display: flex;
    flex-direction: column;
}

:host ::slotted(ux-chat-message-bar) {
    margin-top: auto;
}

.loading-state {
    padding: 2rem;
    text-align: center;
    color: var(--ux-color-text);
    background: var(--ux-color-background-subtle);
    border-radius: var(--ux-border-radius);
    margin: 1rem;
}
